import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AspSlotDeliveryComponent } from './asp-slot-delivery.component';
import { RouterModule, Routes } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

const routes: Routes = [
  {
      path: 'slot',
      component: AspSlotDeliveryComponent,
  },
];

@NgModule({
  declarations: [AspSlotDeliveryComponent],
  imports: [
    CommonModule,
     RouterModule.forChild(routes),
     MatTooltipModule
  ]
})
export class AspSlotDeliveryModule { }
